export const uk = {
    'create-on-preset': 'Створити з шаблону',
    creatives: 'Мої креативи',
    ideas: 'Ідеї креативів',
    presets: 'Стандартні шаблони',
    title: 'Конструктор креативов'
};
